"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render_generic = exports.render = void 0;
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveTileData_1 = require("./diveTileData");
var diveTilemap_sidecar_1 = require("./diveTilemap-sidecar");
var tileSprites_1 = require("./tileSprites");
function render() {
    perf2_sidecar_1.perf2.measure('tilemap render', function () {
        var obj = diveTilemap_sidecar_1.diveTilemap.get();
        render_generic(obj, 0, 0);
    });
}
exports.render = render;
function render_generic(obj, ox, oy) {
    // tileSprites.reset()
    var currentVisibilityIdx = diveSimulationManager_sidecar_1.diveSimulationManager.getCurrentVisibilityIndex();
    // let es = common.getUpdateDeltaScaled()
    for (var iTile = 0; iTile < obj.parts.length; iTile++) {
        var part = obj.parts[iTile];
        // for (let j = 0; j < obj.height; j++) {
        //   for (let i = 0; i < obj.width; i++) {
        //     // TODO: check for in range, or calculate start and end i and j based on camera bounds
        //     let part = obj.parts[j * obj.width + i]
        var tile = part.tile1;
        // Odd to have a null tile
        if (!tile || tile.isNull || tile.type === diveTileData_1.EDiveTile.Null) {
            // TODO: draw debug?
            continue;
        }
        var x = part.x + ox;
        var y = part.y + oy;
        if (voyageCamera_sidecar_1.voyageCamera.isOffScreenXY(x, y, 32)) {
            continue;
        }
        var wasVisible = false;
        var isVisible = false;
        if (part.visibilityIdx === currentVisibilityIdx) {
            isVisible = true;
            wasVisible = true;
            // tileSprites.getNext(x, y, sprites.diveEffectsVisibilityPartial[0])
        }
        if (part.visibilityIdx > 0) {
            wasVisible = true;
        }
        // let isHidden = !isVisible && !wasVisible
        if (!wasVisible) {
            tileSprites_1.tileSprites.getNext(x, y, sprites_sidecar_1.sprites.diveTilesVisibilityNone[0]);
            continue;
        }
        var frame = tile.frames[0];
        if (tile.type === diveTileData_1.EDiveTile.Wall) {
            if (part.variant === 1) {
                frame = tile.frames[1];
            }
            if (part.variant === 2) {
                frame = tile.frames[2];
            }
        }
        if (tile.type === diveTileData_1.EDiveTile.StairsUp ||
            tile.type === diveTileData_1.EDiveTile.StairsDown) {
            // Add backing tile
            tileSprites_1.tileSprites.getNext(x, y, sprites_sidecar_1.sprites.diveTiles00C0[0]);
        }
        // Add floor below certain tiles
        if (tile.type === diveTileData_1.EDiveTile.DoorOpen) {
            tileSprites_1.tileSprites.getNext(x, y, sprites_sidecar_1.sprites.diveTiles00C0[0]);
        }
        var image = tileSprites_1.tileSprites.getNext(x, y, frame);
        if (part.shadow === 2) {
            tileSprites_1.tileSprites.getNext(x, y, sprites_sidecar_1.sprites.diveTiles50C40[0]);
        }
        if (part.shadow === 1) {
            tileSprites_1.tileSprites.getNext(x, y, sprites_sidecar_1.sprites.diveTiles51C41[0]);
        }
        if (!isVisible) {
            tileSprites_1.tileSprites.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsVisibilityPartial[0]);
        }
        // Visiblity start
        // if (!isvi) {
        //   tileSprites.getNext(x, y, sprites.diveEffectsVisibilityPartial[0])
        // }
        // TODO: fancier rendering here?
    }
}
exports.render_generic = render_generic;
